import { CSSProperties, ReactNode } from "react";

type TitleBlockProps = {
  title: string;
  subtitle?: string;
  children?: ReactNode;
  style?: CSSProperties;
  innerStyle?: CSSProperties;
  headingStyle?: CSSProperties;
};

export function TitleBlock({
  title,
  subtitle,
  children,
  style,
  innerStyle,
  headingStyle,
}: TitleBlockProps) {
  return (
    <div className="legal-title-shell" style={style}>
      <div className="w-layout-blockcontainer container-2 w-container">
        <div
          className="div-block-3"
          style={{ borderRadius: 50, background: "#f5f5f5", ...innerStyle }}
        >
          <div>
            <div className="logo-wrapper">
              <a href="/" className="w-inline-block" aria-label="Iris home">
                <img
                  src="/iris-logo-mark.svg"
                  loading="lazy"
                  alt="Iris"
                  className="logo"
                />
                <span className="legal-title-brand-text">IRIS</span>
              </a>
            </div>
            <div className="w-layout-vflex flex-block-4">
              <h1 className="heading" style={{ fontSize: "27px", fontWeight: 400, ...headingStyle }}>
                {title}
              </h1>
              {subtitle ? (
                <div className="w-layout-vflex flex-block-3">
                  <p className="body-text testimonial _9">{subtitle}</p>
                </div>
              ) : null}
              {children ? (
                <div style={{ marginTop: 24 }}>{children}</div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
